<template>
  <form autocomplete="off" v-on:submit.prevent="submit(form)" class="form">
    <div class="flex form-row">
      <div class="col-6">
        <label for="current_password">Current Password <span>*</span></label>
        <input type="password" name="current_password" placeholder="Current Password"
               v-model="form.current_password"
               v-validate="'required'"/>
        <span v-if="errors.has('current_password')">{{ errors.first('current_password') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="password">Password <span>*</span></label>
        <input id="password" type="password" name="password" placeholder="Password" ref="password"
               v-model="form.password" v-validate="'required|min:6'" />
        <span class="help">must be at least 6 characters</span><br>
        <span v-if="errors.has('password')">{{ errors.first('password') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <div class="col-6">
        <label for="password_confirmation">Confirm Password <span>*</span></label>
        <input id="password_confirmation" type="password" name="password_confirmation" placeholder="Confirm Password"
               v-model="form.password_confirmation" v-validate="'required|confirmed:password'"
               data-vv-as="password" />
        <span v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</span>
      </div>
    </div>
    <div class="flex form-row">
      <button class="body-8" :disabled="pending || errors.any()">Submit</button>
    </div>
  </form>
</template>

<script>
    export default {
        name: "UpdatePasswordForm",
        data() {
            return {
                form: {
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                },
                pending: false,
            }
        },
        methods: {
            submit(form) {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        this.$emit('submit', form);
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>